/* eslint-disable indent */
import { sendAnalyticEvent } from '@src/components/web-analytic';
import { Product, analyticEvents } from '@src/constants';

const sendEvent = (
  event: string,
  presetEvent: string,
  isPreset: boolean,
  params?: unknown
) => {
  isPreset
    ? sendAnalyticEvent(presetEvent, params)
    : sendAnalyticEvent(event, params);
};

export const handleRegistrationComplete = (
  product: Product,
  isPreset: boolean,
  params?: unknown
) => {
  switch (product) {
    case Product.APARTMENT:
      sendAnalyticEvent(analyticEvents.authFlatRegistrationCompleted, params);
      break;
    case Product.HOUSE:
      sendEvent(
        analyticEvents.authHouseRegistrationCompleted,
        analyticEvents.authHouseRegistrationCompletedPreset,
        isPreset,
        params
      );
      break;
    case Product.NS:
      sendAnalyticEvent(analyticEvents.authNSRegistrationCompleted, params);
      break;
    case Product.PETS:
      sendEvent(
        analyticEvents.authPetRegistrationCompleted,
        analyticEvents.authPetRegistrationCompletedPreset,
        isPreset,
        params
      );
      break;
    case Product.SPORT:
      sendAnalyticEvent(analyticEvents.authSportRegistrationCompleted, params);
      break;
    case Product.MITE:
      sendAnalyticEvent(analyticEvents.authMiteRegistrationCompleted, params);
      break;
    case Product.PETS_TELEVET_PLUS:
      sendAnalyticEvent(analyticEvents.petTelRegCompleted, params);
      break;
    default:
      break;
  }
};
